import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  back: {
    defaultMessage: 'Back',
    id: 'aITs2P',
    description: 'Text for a back button that goes back to the previous step in the new return creation process',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: '2gwY06',
    description: 'Text for a cancel button that cancels creating a new return',
  },
  configureReturnStepText: {
    defaultMessage: 'Configure Return',
    id: 'U0RRS5',
    description: 'Text indicating that the user is in the "Configure Return" step of the new return creation process',
  },
  confirmRequest: {
    defaultMessage: 'Confirm Request',
    id: 'Wc5kZX',
    description: 'Text for a button that confirms creating a new return',
  },
});
